import { useEffect, useMemo, type ReactNode } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { buildTheme } from './theme';
import { useThemeMode } from './hooks/useThemeMode';

export default function ThemedApp({ children }: { children: ReactNode }) {
  const { mode } = useThemeMode();
  const theme = useMemo(() => buildTheme(mode), [mode]);
  // Keep the status-bar colour on the active theme when it changes at runtime. The inline
  // head script already set it from localStorage before first paint (no flash); this covers toggles.
  useEffect(() => {
    document.getElementById('theme-color')?.setAttribute('content', theme.palette.background.paper);
  }, [theme]);
  return (
    <ThemeProvider theme={theme}>
      {/* enableColorScheme: without it the native scrollbars, autofill and date
          popups stay light against a dark app. */}
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
